//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
    btnDiv: {
        float: "right",
        '@media (max-width: 768px)': {
            float: "",
        }
    },

    filterBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 5,
        marginBottom: 20,
        cursor: "pointer",
        padding: "4px 8px",
        marginRight: 10,
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },

    exportBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 5,
        marginBottom: 20,
        cursor: "pointer",
        padding: "4px 8px",
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },

    resendBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        cursor: "pointer",
        padding: "4px 8px",
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },

    filterCard: {
        boxShadow: " 10px 10px 10px #00000029 !important",
        border: " 1px solid #707070",
        borderRadius: "20px !important",
        zIndex: 100,
        marginBottom: 20,
    },
    filterCardGridContainer: {
        height: "100%",
    },
    filterCardGrid: {
        borderRight: "1px solid #0000004D",
        alignSelf: "center",
        "@media (max-width: 768px)": {
            border: "none"
        }
    },
    filterCardBtnGrid: {
        alignSelf: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "@media (max-width: 768px)": {
            flexDirection: "row",
            justifyContent: "space-around"
        }
    },
    filterCardApplyBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        width: 70,
        marginTop: 5,
        cursor: "pointer",
        padding: "4px 8px",
        "&:hover": {
            backgroundColor: "#0a72ba",
        },
        "@media (max-width: 768px)": {
            marginTop: 0,
        }
    },
    filterCardResetBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        cursor: "pointer",
        padding: "4px 8px",
        width: 70,
        "&:hover": {
            backgroundColor: "#0a72ba",
        },
    },

    yesBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 10,
        cursor: "pointer",
        padding: "4px 8px",
        width: 70,
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },

    noBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 10,
        marginRight: 10,
        cursor: "pointer",
        padding: "4px 8px",
        width: 70,
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },
    menuItem: {
        fontSize: 14,
    },

    dateInput: {
        width: "100%",
    },

    tableHeadings: {
        "@media (max-width: 1316px)": {
            width: 120,
        }
    },
    dateColumn: {
        width: 70,
        "@media (max-width: 1316px)": {
            width: 120,
        }
    },
    sendEmailBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 5,
        marginBottom: 20,
        cursor: "pointer",
        padding: "4px 8px",
        marginRight: 10,
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },
    sendBtn: {
        border: "none",
        backgroundColor: "#0a72ba",
        color: "#fff",
        borderRadius: "5px",
        marginTop: 5,
        cursor: "pointer",
        padding: "6px 12px",
        marginLeft: 10,
        width: 90,
        "&:hover": {
            backgroundColor: "#0a72ba",
        }
    },
    cancelBtn: {
        padding: "6px 12px",
        backgroundColor: "#ededed",
        border: "none",
        borderRadius: 5,
        color: "#000",
        width: 90,
        cursor: "pointer",
    },
    emailPopTextField: {
        width: "500px",
        marginBottom: 20,
        "@media (max-width: 600px)": {
            width: 300
        },
        "@media (max-width: 400px)": {
            width: 250
        }
    },
    exportBtn1: {
        color: "#fff",
        width: "64px",
        height: "30px",
        fontSize: "14px",
        cursor: "pointer",
        fontFamily: "segoe-ui",
        borderRadius: 5,
        backgroundColor: "#0a72ba",
        border: "none",
        // marginLeft:"38%",
    
        "@media (max-width: 600px)": {
          marginTop: "4rem",
        },
      },
      // CSVlink: {
      //   display: "none",
      // },
}))